module.exports = __webpack_public_path__ + "img/graph-icon.2aa709d3.svg";